import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next'
import { AccordionDetails, Grid, Tooltip, Box } from '@mui/material';

import { PdfIcon, CustomTypography, CustomTextField, Title, IconContainer, ContainerIconsRight, Content, ContainerText, CustomAccordionSummary, CustomAccordion } from './styles';

import { FormViewer } from '../../components/FormViewer';
import { ExpandMoreRounded, PlayCircle } from '@mui/icons-material';

import { useLocation } from 'react-router-dom';

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../Context/PermissionsContext';
import { useOffline } from '../../Context/OfflineContext';
import { CustomButtonV2 } from '../styles';

export const WorkPermitDetailTab = ({
    areaData,
    detailForm, 
    formsTitles,
    loadingForm,
    expanded,
    data,
    formVersion,
    formRef,
    showPreActiveButton,
    showActiveButton,
    showResumeButton,
    showPauseButton,
    showFormButtons,
    showDeleteButton,
    changeState,
    showInstanceState,
    observations,
    setObservations,
    setErrorObservations,
    errorObservations,
    isExternal,
    handleOpenDelete,
    handleChange,
    btnCancel,
    processAction,
    downloadPdf,
    currentFormRef,
    isLotoWorkflow,
    handleOpenQrScan
}) => {

    const location = useLocation();
    const { t } = useTranslation();
    const ability = useAbility(AbilityContext);
    const { connectionStatus } = useOffline();
    // Hide cancel button when processing a "viabilización" study with no pending actions
    const hideBtnCancel = location.state?.row.notificationId;

    return (
        <Fragment>
            {detailForm.map((obj, index) => (
                <CustomAccordion 
                    key={`${obj.id}-${index}`} 
                    expanded={expanded === `panel${areaData}${index+1}`} 
                    onChange={handleChange(`panel${areaData}${index+1}`, obj, index, areaData)}
                >
                    <CustomAccordionSummary
                        expandIcon={<ExpandMoreRounded />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"             
                    >
                        <Content>
                            <ContainerText>
                                <CustomTypography mr={2}>{formsTitles?.[index] || `${t('workflow.detail.form')} ${index+1}`}</CustomTypography>
                            </ContainerText>

                            <ContainerIconsRight>
                                {(obj.notification && connectionStatus) &&
                                    <Tooltip title={t("common.actions.process")} id="process-button-tool">
                                        <IconContainer id="process-button-cont" onClick={() => {
                                            if (isLotoWorkflow && handleOpenQrScan) {
                                              handleOpenQrScan({ ...obj, isTabAction: true }, undefined)
                                            } else {
                                              processAction(obj)
                                            }
                                        }}>
                                            <PlayCircle id="process-button" size="small"/>
                                        </IconContainer>
                                    </Tooltip>
                                }
                                {(ability.can("GetFormData") && connectionStatus) &&
                                    <Tooltip title={t("common.downloadPdf")} id="pdf-button-tool">
                                        <Box 
                                            sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}} 
                                            component="span" 
                                            onClick={() => downloadPdf(obj, index, areaData)}
                                        >
                                            <PdfIcon id="pdf-button">picture_as_pdf</PdfIcon>
                                        </Box>
                                    </Tooltip>
                                }
                            </ContainerIconsRight>
                        </Content>
                    </CustomAccordionSummary>
                    <AccordionDetails id='Acordeon Details'>
                        <Grid container>
                            <Grid item xs={12}>
                                {(!loadingForm && expanded === `panel${areaData}${index+1}`) && 
                                    <FormViewer 
                                        form={obj.form?.structure} 
                                        data={obj.data} 
                                        characteristics={obj.characteristics} 
                                        formData={data}
                                        isDetail={1}
                                        hideFiles={true}
                                        formVersion={formVersion}
                                        formRef={formRef}
                                        loadingForm={loadingForm}
                                        formName={obj.extraFormsTitles?.[index] || (t('workflow.detail.form') + ' ' + index+1)}
                                        currentFormRef={currentFormRef}
                                    />
                                }
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </CustomAccordion>
            ))}
            {detailForm.length === 0 &&
              <div style={{ marginTop: '2rem' }}>
                <Title sx={{ textAlign: 'center', margin: 'auto' }}>
                  {areaData === 0 ?
                    t('workflow.detail.formsActiveEmpty') :
                    t('workflow.detail.formsPendingEmpty')
                  }
                </Title>
              </div>
            }
            <Grid container spacing={2} pt={1} pb={3} paddingX={2} width="100%">
                {showPreActiveButton &&
                    <Grid item xs={2}>
                        <CustomButtonV2 type="accept" sx={{ marginTop: 2 }} onClick={() => showInstanceState(changeState, 10008)}>{t('workflow.detail.preActivate')}</CustomButtonV2>
                    </Grid>
                }
                {showActiveButton &&
                    <Grid item xs={2}>
                        <CustomButtonV2 type="accept" sx={{ marginTop: 2 }} onClick={() => showInstanceState(changeState, 10008)}>{t('workflow.detail.activate')}</CustomButtonV2>
                    </Grid>
                }
                {/* Show daily closing button */}
                {(showResumeButton && showPauseButton && (ability.can("DailyClosing"))) &&
                  <Grid item xs={2}>
                    <CustomButtonV2 type="accept" sx={{ marginTop: 2 }} onClick={() => showInstanceState(changeState, 10007)}>
                      {t('workflow.detail.continue') }
                    </CustomButtonV2>
                  </Grid>
                }
                {/* Show resume button */}
                {(showResumeButton && !showPauseButton) &&
                  <Grid item xs={2}>
                    <CustomButtonV2 type="accept" sx={{ marginTop: 2 }} onClick={() => showInstanceState(changeState, 10009)}>
                      {t('workflow.detail.resume')}
                    </CustomButtonV2>
                  </Grid>
                }
                {/* Show suspend button */}
                {(showPauseButton && (ability.can("Suspend"))) &&
                    <Grid item xs={2}>
                        <CustomButtonV2 type="accept" sx={{ marginTop: 2 }} onClick={() => showInstanceState(changeState, 10006, false, true)}>{t('workflow.detail.pause')}</CustomButtonV2>
                    </Grid>
                }
                {(showFormButtons && (ability.can("ApproveWorkflowData") || ability.can("ApproveWorkflowDataCredentials"))) &&
                <>
                    {(row.type === 'check_form' || row.type === 'check_form_credentials') &&
                        <Grid item xs={12} mt={2}>
                            <CustomTypography>{t('forms.characteristics.observations')}:</CustomTypography>
                            <CustomTextField
                                value={observations || ''}
                                size="small"
                                type="text"
                                onChange={e => {
                                        setObservations(e.target.value)
                                        setErrorObservations('')
                                    }
                                }
                                error={!(!errorObservations)}
                                helperText={errorObservations}
                                multiline
                                rows={2}
                            />
                        </Grid>
                    }
                    <Grid item xs={2}>
                        <CustomButtonV2 type="approve" sx={{ marginTop: 2 }} onClick={() => showInstanceState(approveForm, true, null, null, "approve")}>{t('workflow.detail.approve')}</CustomButtonV2>
                    </Grid>
                    <Grid item xs={2}>
                        <CustomButtonV2 type="reject" btnType="reject" sx={{ marginTop: 2 }} onClick={() => showInstanceState(approveForm, false, null, null, "approve")}>{t('workflow.detail.reject')}</CustomButtonV2>
                    </Grid>
                </>
                }
                <Grid item xs></Grid>
                <Grid item xs={2}>
                    {(showDeleteButton && !isExternal && ability.can("DeleteWorkflowData")) &&
                       <CustomButtonV2 
                       sx={{ visibility: hideBtnCancel === undefined ||
                        btnCancel === false
                         ? 'hidden' : 'visible' }} 
                       variant='contained' 
                       type="delete" 
                       onClick={handleOpenDelete}
                       >
                        {t('workflow.detail.cancel')}
                       </CustomButtonV2>
                    }
                </Grid>
            </Grid>
        </Fragment>
    )
}